<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/school-desktop-banners/arni-school-of-pharmacy.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-pharmacy.webp">
        <img
            src="assets/img/mobile-banners-schools/arni-school-of-pharmacy.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 xl:p-4 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400  active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Courses</a>
            <a href="#specialisation"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Specialization</a>
            <a href="#dean-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Dean's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Expert
                Faculty</a>
            <!--<a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>
        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Pharmacy</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify">ARNI School of Pharmacy stands as a pillar of excellence in
                pharmaceutical education, fostering the next generation of professionals equipped to lead pharmaceutical
                sciences, healthcare, and research. We believe that not only doctors, but pharmacists also play an
                important role in improving public or patient health by advancing medicines and drug therapy to support
                medical professionals.
            </p>
            <p class="text-gray-500 text-justify mt-2">We provide an ideal environment for students to understand the
                principles and complexities of drug formulation, clinical applications, regulatory affairs, and
                pharmacology, which leads students to meet and resolve issues and challenges of the pharmaceutical
                industry. Our syllabus is designed under the supervision of expert faculty and scholars with an
                appropriate combination of theory, research, and practical training.
            </p>
            <p class="text-gray-500 text-justify mt-2">With our course curriculum, we not only focus on developing deep
                scientific knowledge but also foster critical thinking, ethical decision-making, and a commitment to the
                best patient care. With easy access to well-maintained laboratories, experienced faculty, and strong
                industry connections, our students are equipped with relevant education that goes beyond textbooks and
                prepares them to take on real-world challenges. The Bachelor of Science in Pharmacy from ARNI University
                explores meaningful careers in a rapidly evolving field.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Vision -</strong> To be one of the leading names in
                educational institutions serving to pharmacy industries, research, and practice, contributing to the
                advancement of healthcare through innovative solutions, ethical practices, and global impact.

            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Mission -</strong> Provide comprehensive academic
                programs and practical knowledge that collaborate with advanced pharmaceutical sciences. Train students
                to prioritize patient care and safety while maintaining the work culture.
            </p>
        </div>

        <div id="courses" class="section px-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">ARNI School of Pharmacy offers Bachelor's in Pharmacy and Diploma in
                Pharmacy courses, focusing on providing high-quality education in pharmacy for students. The
                institution's experienced faculty, modern facilities, and emphasis on practical learning ensure that
                students receive a holistic education. Our courses blend pharmaceutical theory with practical laboratory
                experiences, ensuring that students are equipped with a sound understanding of drug development,
                pharmacovigilance, and clinical applications.
            </p>
            <p class="text-gray-500 text-justify">The laboratories are equipped with the latest tools and technologies,
                providing hands-on experience in pharmaceutical analysis, formulation development, and pharmacology.
                Classrooms are designed for interactive learning and equipped with visual aids. ARNI School of Pharmacy
                aims to create a conducive environment for students to excel academically and become competent
                pharmacists in the healthcare industry.
            </p>
            <!-- <ul class="list-disc">
                 <li class="text-gray-500 text-justify my-2">
                     Diploma Programs
                     <ul class="list-disc ml-6">
                         <li>D.Pharmacy</li>
                     </ul>
                 </li>
                 <li class="text-gray-500 text-justify my-2">
                     Undergraduate Programs
                     <ul class="list-disc ml-6">
                         <li>B.Pharmacy</li>
                     </ul>
                 </li>
                 <li class="text-gray-500 text-justify my-2">
                     Postgraduate Programs
                     <ul class="list-disc ml-6">
                         <li>M. Pharmacy Pharmaceutics</li>
                         <li>M. Pharmacy Pharmacognosy</li>
                         <li>M. Pharmacy Pharmacology</li>
                         <li>M. Pharmacy Pharmaceutical Chemistry</li>
                     </ul>
                 </li>
             </ul>-->
            <p class="text-gray-500 text-justify"><strong>Scope:</strong> A bachelor's degree in pharmacy can be used to
                work as a pharmacy technician in a variety of situations, including manufacturing, government healthcare
                positions, retail and hospital pharmacies, and diploma programs in pharmacy (D. Pharmacy).
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 mt-2 text-justify"> Graduates with a Bachelor of Pharmacy (B. Pharmacy) can
                    specialize in clinical pharmacy, pharmaceutical research, or industrial jobs like production,
                    quality assurance, and regulatory affairs. They can also become licensed pharmacists.
                </li>
                <li class="text-gray-500 mt-2 text-justify"> Additionally, they can work in academia or as
                    pharmaceutical consultants, advancing research, education, and healthcare policy.
                </li>
                <li class="text-gray-500 mt-2 text-justify"> Graduates can manage drug dispensing, patient counseling,
                    and dosage regulations in hospitals and clinics.
                </li>
                <li class="text-gray-500 mt-2 text-justify"> Pursuing a career in teaching and training future pharmacy
                    students after higher studies.
                </li>
                <li class="text-gray-500 mt-2 text-justify"> Graduates can pursue M.Pharm, MBA (Pharma), Pharm.D., or
                    appear for global licensure exams like GRE, TOEFL, GPAT, or NAPLEX.
                </li>
                <li class="text-gray-500 mt-2 text-justify"> Many graduates enter pharmaceutical marketing, brand
                    management, or medical representative roles.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">The ARNI School of Pharmacy would be your ideal parent on the
                journey towards the world of medicine and healthcare. Join us to create a healthier, brighter future
                with us.</p>
            <h4 class="text-xl font-bold mb-2">Career Opportunities</h4>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2"><span class="font-semibold">Pharmacist (Clinical or Retail) -</span>
                    Increase drug awareness by providing the right information to the patients. Dispense medication and
                    counsel patients to ensure correct usage of prescriptions.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Drug Safety Associate / Pharmacovigilance Executive -</span>
                    Enhance patient safety by monitoring and reporting on adverse drug reactions.
                </li>
                <li class="text-gray-500 my-2"><span
                    class="font-semibold">Pharmaceutical Scientist / R&D Executive -</span> Conduct formulation
                    research, bioequivalence studies, and product innovation.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Medical Representative / Pharma Sales Executive -</span>
                    Promotion of marketing of new drugs, educate healthcare professionals about the pharmaceutical
                    products.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Regulatory Affairs Executive -</span> Handle
                    the approval processes and compliance documentation for new drug launches.
                </li>
            </ul>

            <h2 class="text-xl font-bold mb-2">Arni University’s Contribution to Emerging Technologies</h2>
            <p class="text-gray-500 my-2">At ARNI University, we are dedicated to educating the pharmacy professionals
                of the future who will be technically skilled, ethically grounded, and globally competitive. The ARNI
                School of Pharmacy believes it offers more than just a degree, we provide a transformative learning
                experience. The pharmacy school has modern, state-of-the-art pharmaceutical laboratories, pharmaceutical
                instrumentation rooms, and pharmaceutical simulation centers that allow students to gain applicable
                experience in drug compounding, clinical practice, and pharmaceutical manufacturing.</p>
            <p class="text-gray-500 my-2">With our strong relationships with industry, students can do live research
                projects, co-op internships, and industrial visits that allow them to see advanced developments in drug
                research and production. We support innovation and critical thinking skills, we conduct workshops, paper
                presentations, and student research projects (with the guidance of qualified faculty).
            </p>
            <p class="text-gray-500 my-2">The University’s placement and career development cell continues to support
                students with resume writing, mock interviews with industry professionals, and direct introductions to
                industry-specific recruiters. Whether you want to choose a career in a hospital, work for a
                multinational drug company, or go on to progress research, ARNI will ensure every student is ready and
                confident.
            </p>
            <p class="text-gray-500 my-2">With a commitment to quality learning, quality mentorship, and quality
                industry relevance, ARNI University is a credible, high-quality institution that stands for quality
                pharmacy education.
            </p>

            <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2">We have experienced faculty who have an industry & clinical background,
                    ensuring academic insights with practical application in pharma and healthcare.
                </li>
                <li class="text-gray-500 my-2">Our students will train in modern laboratories equipped with all
                    essential instruments used in actual pharmaceutical manufacturing and quality testing.
                </li>
                <li class="text-gray-500 my-2">Our strong industry connections will help students to get placed in
                    well-reputed firms and get internship opportunities to implement their learnings in a real setup.
                    Moreover, our placement cell guides students on every step of their career.
                </li>
                <li class="text-gray-500 my-2">Our syllabus includes not only technical knowledge but also
                    communication, entrepreneurship, and regulatory training to boost employability.
                </li>
                <li class="text-gray-500 my-2">We encourage students to engage in live research projects, publish
                    papers, and participate in national pharma forums and competitions.
                </li>
                <li class="text-gray-500 my-2">We offer quality pharmacy education at an affordable cost, along with
                    scholarships for deserving students to pursue their dreams.
                </li>
            </ul>

            <p class="my-2 text-gray-500 font-semibold">The ARNI School of Pharmacy would be your ideal parent on the
                journey towards the world of medicine and healthcare. Join us to create a healthier, brighter future for
                us.
            </p>
        </div>
    </div>
    <div id="specialisation" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">Pharmacy Disciplines &
                Specializations</h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
                <div
                    *ngFor="let department of departments"
                    class="bg-white p-5 rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                >
                    <div class="flex items-center mb-4">
                        <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                        <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                    </div>
                    <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                        <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                            <li *ngFor="let branch of department.branches">{{ branch }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
            <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
                <div>
                    <p class="text-3xl font-bold">200+</p>
                    <p class="text-lg">Programs</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">500+</p>
                    <p class="text-lg">Faculties</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">11000+</p>
                    <p class="text-lg">Students</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">120+</p>
                    <p class="text-lg">Acre of campus</p>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full">
        <div id="dean-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img src="assets/img/dean.jpeg" alt="Dean" class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Prof. (Dr.) Neeraj Bhandari
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto custom-scrollbar">
                <h2 class="text-2xl font-bold mb-2">Dean’s Message</h2>
                <p class="text-gray-700 text-justify">
                    I am very excited to write this message as Dean of the ARNI School of Pharmacy for all the talented
                    students and valuable faculty members. Not only me, but every and each person who is associated with
                    ARNI University is passionate about bringing something new, something positive to the society. Thus,
                    we are on a mission to prepare world-class pharmacists and pharmaceutical scientists who help to
                    transform this world into a better place.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    We have a team of well-talented faculty that helps students to be prepared for a profession where
                    they will have an impact on the medication-focused healthcare spectrum. Success and the future of
                    our students are very important to our stakeholders, alumni, teachers, and staff. Our team of highly
                    esteemed educators, researchers, and medical professionals collaborates to offer a setting where you
                    can realize your professional aspirations.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    As we create exceptional professionals in India for the world, I extend a warm welcome to you on our
                    verdant campus of the Department of Pharmacy and hope you will fully commit to our aim of fostering
                    excellence in the pharmaceutical profession.
                </p>
                <p class="text-gray-700 mt-2 text-justify">I hope everyone has a very successful future!</p>
                <p class="text-gray-700 mt-2 text-justify">With best wishes,</p>
                <p class="text-gray-700 mt-2 text-justify font-bold">Prof. (Dr.) Neeraj Bhandari
                </p>
                <p class="text-gray-700 mt-2 text-justify">Dean, ARNI School of Pharmacy</p>
                <p class="text-gray-700 mt-2 text-justify">ARNI University</p>
            </div>
        </div>

        <div id="whats-happening" class="w-full">
            <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
                <div class="container mx-auto px-6">
                    <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                            <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                                <!--<p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                                <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                                <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-10">
                        <a
                            href="/whats-happening/event-calendar"
                            class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                        >
                            View More
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div id="expert-faculty" class="w-full">
            <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="relative w-full max-w-6xl overflow-hidden">
                    <div
                        class="flex  transition-transform duration-300 ease-in-out"
                        [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                    >
                        <div
                            *ngFor="let faculty of faculties"
                            class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                        >
                            <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                                <div class="h-[140px] flex items-center justify-center">
                                    <img
                                        [src]="faculty.image"
                                        alt="faculty image"
                                        class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                    />
                                </div>
                                <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                    <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                    <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    (click)="prev()"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-left text-[#012E26]"></i>
                </button>
                <button
                    (click)="next()"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-right text-[#012E26]"></i>
                </button>

                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('/about/faculty')">
                    View All Faculty
                </button>
            </div>
            <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="w-full">
                    <div
                        *ngFor="let faculty of faculties | slice:0:3"
                        class="flex flex-col items-center p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px] w-full">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                            (click)="goTo('/about/faculty')">
                        View All Faculty
                    </button>
                </div>
            </div>
        </div>

        <!--<div id="testimonials" class="py-16 bg-white font-montserrat">
            <div class="container mx-auto px-4 text-center">
                <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
                <div class="testimonial-slider relative">
                    <div class="overflow-hidden px-2">
                        <div
                            class="flex transition-transform duration-500 ease-in-out"
                            [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                        >
                            <ng-container *ngFor="let group of groupedTestimonials">
                                <div class="w-full flex-shrink-0 flex pb-4 justify-center">
                                    <div
                                        *ngFor="let testimonial of group"
                                        class="w-full md:1/2 lg:w-1/3 px-3"
                                    >
                                        <div
                                            class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                            <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                                <div
                                                    class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                                >
                                                    <div class="w-24 h-24 rounded-full bg-white p-1">
                                                        <img
                                                            [src]="testimonial.image"
                                                            [alt]="testimonial.name"
                                                            class="w-full h-full rounded-full object-cover"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-16 pb-8 px-6">
                                                <h3
                                                    class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                                >
                                                    {{ testimonial.name }}
                                                </h3>
                                                <div class="flex justify-center mb-4">
                                                    <i
                                                        class="fa fa-star text-yellow-400"
                                                        *ngFor="let star of [1, 2, 3, 4, 5]"
                                                    ></i>
                                                </div>
                                                <p class="text-gray-700 text-center mb-6">
                                                    {{ testimonial.feedback }}
                                                </p>
                                                <div class="text-center text-sm text-gray-600">
                                                    <p class="font-semibold">{{ testimonial.course }}</p>
                                                    &lt;!&ndash;        <p class="font-bold text-[#012E26]">
                                                                Placed In:
                                                                <span class="text-[#00BFA5]">
                                  {{ testimonial.company }}
                                </span>
                                                            </p>&ndash;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    &lt;!&ndash; Pagination Dots &ndash;&gt;
                    <div class="flex justify-center mt-8 space-x-2">
                        <button
                            *ngFor="let group of groupedTestimonials; let i = index"
                            [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                            class="w-3 h-3 rounded-full transition-all duration-300"
                            (click)="setTestimonialSlide(i)"
                        ></button>
                    </div>
                </div>

                <div class="flex justify-center mt-10">
                    <a
                        href="/quick-links/student-testimonial"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>-->

        <div id="gallery">
            <div class="container-fluid mb-10">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                        <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                             class="w-full h-[500px] shadow-lg">
                    </div>
                    <div class="w-full md:w-2/5 md:pl-4">
                        <iframe class="w-full h-[500px] object-cover shadow-lg"
                                src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="recruiters" class="w-full">
            <div class="bg-blue-100 text-center font-sans py-12">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
                <div class="flex items-center justify-center gap-6 py-4">
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="prevSlide()">&#10094;
                    </button>
                    <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                        <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                             [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                            <div *ngFor="let recruiter of recruiters"
                                 class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                                <img [src]="recruiter.logo" [alt]="recruiter.name"
                                     class="max-w-[80px] sm:max-w-[100px] h-auto">
                            </div>
                        </div>
                    </div>
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="nextSlide()">&#10095;
                    </button>
                </div>
                <!--                <button class="mt-4 bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-full">View all</button>-->
            </div>
        </div>
    </div>
</section>
